export default __webpack_public_path__ + "static/media/fac.a03a6dc5.png";